import FootballStringifier from "../../../../../services/stringifiers/football-stringifier";
import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";
import { getPatComplete } from "../../../utils/context-utils";

export default class PatComplete extends Rule {
    static ruleApplies(fragment, play, gameContext) {
        const { summaryContext } =
            FootballStringifier.generateSummary(play, gameContext) || {};
        return (
            play.historyContains(FootballState.PatTry) &&
            (fragment.associatedState === FootballState.PatCompleted ||
                ([
                    FootballState.EndOfPlay,
                    FootballState.NoPenaltyEndOfPlay
                ].some((state) => state === fragment.associatedState) &&
                    getPatComplete(
                        summaryContext,
                        play.contextSnapshot,
                        play,
                        gameContext.gameConfig
                    )))
        );
    }

    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.PAT &&
            PatComplete.ruleApplies(fragment, play, gameContext)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const patFragment =
            play.getFirstFragment(FootballState.FieldGoalFakeRun) ||
            play.getFirstFragment(FootballState.FieldGoalFakePass) ||
            play.getFirstFragment(FootballState.PatKick) ||
            play.getFirstFragment(FootballState.PatPass) ||
            play.getFirstFragment(FootballState.DropKick) ||
            play.getFirstFragment(FootballState.Run);
        const points = patFragment.getScoringPoints(gameContext.gameConfig);

        gameContext.increaseTeamPossessionScore(points);
        ruleContext.playPoints = points;
    }
}
